import WalkthroughComponent from './WalkthroughComponent';

export default WalkthroughComponent;
